import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BankStatementRuleExpressionTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.expression.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BankStatementRuleExpressionTypeEnum} enumeration values */
export const BankStatementRuleExpressionTypeEnumI18n: EnumI18nInterface<BankStatementRuleExpressionTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BankStatementRuleExpressionTypeEnum.OPERATOR]: 'Оператор',
    [BankStatementRuleExpressionTypeEnum.CONDITION]: 'Условие',
  },
  [I18nLocalesEnum.EN_US]: {
    [BankStatementRuleExpressionTypeEnum.OPERATOR]: 'Operator',
    [BankStatementRuleExpressionTypeEnum.CONDITION]: 'Condition',
  },
};
